import React, { useState } from "react";
import StartCoursePopup from "../components/StartCoursePopup";
import "./FinalCTA.css";

const FinalCTA = () => {
  const [openPopup, setOpenPopup] = useState(false);

  const handleAdvisor = () => {
    alert("Talk to Advisor clicked");
  };

  return (
    <section className="fcta-section">
      <div className="fcta-container">
        <h2 className="fcta-title">Not Sure Where to Start?</h2>

        <p className="fcta-subtitle">
          We guide you step-by-step until you land your dream job.
        </p>

        <div className="fcta-buttons">
          <button className="fcta-btn-outline" onClick={handleAdvisor}>
            Talk to Advisor
          </button>

          <button className="start-btn" onClick={() => setOpenPopup(true)}>
            Start Course Now
          </button>
        </div>

        <StartCoursePopup
          isOpen={openPopup}
          onClose={() => setOpenPopup(false)}
        />

        <div className="fcta-points">
          <span>✔ No Experience Required</span>
          <span>✔ 100% Placement Support</span>
          <span>✔ Flexible Learning</span>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
